import { connect } from "react-redux";
import AppleSignin from "react-apple-signin-auth";
import { signIn } from "@actions/auth-actions";
import { Button } from "@components/core";
import { authTypes } from "@utils/constants/authTypes";
import basePath from "@utils/basePath";
import logger from "@utils/logger";

const Apple = ({
  // eslint-disable-next-line no-shadow
  signIn, authSuccess, authError,
}) => {
  async function onAppleResponse(appleResponse) {
    try {
      const res = await signIn({ apple_response: appleResponse });
      authSuccess(res.user, authTypes.apple);
    } catch (err) {
      authError(err, authTypes.apple);
    }
  }

  const customAppleButton = (props) => (
    <Button
      variant="dark"
      fullWidth
      leftIconName="apple-logo"
      className="py-0"
      {...props}
    >
      {""}
    </Button>
  );

  // Documentation a propos de apple sign in
  // https://www.npmjs.com/package/react-apple-signin-auth
  // https://dev.to/onygami/how-to-add-signin-with-apple-on-your-website-43m9
  return (
    <div className="flex-grow-1">
      <AppleSignin
        authOptions={{
          clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID,
          scope: "email name",
          redirectURI: basePath(),
          usePopup: true,
        }}
        onSuccess={onAppleResponse}
        onError={(err) => logger.error(err)}
        render={(props) => customAppleButton(props)}
      />
    </div>
  );
};

export default connect(null, { signIn })(Apple);
